/* Spec-column dropdowns (.llm-specs__more — "View All ▾", "Aluminum Hydroxi… ▾") close on a click
 * ANYWHERE, not only on their own caret. Owner 2026-10-21: "You have to click the up arrow in order
 * for the dropdown to close. Should be able to click anywhere."
 *
 * Native <details> only toggles from its own <summary>, so this adds the two missing behaviours:
 *   · a click outside an open dropdown closes it (a click INSIDE its list does not — the reader may
 *     be selecting text)
 *   · opening one closes any other, so two panels never overlap
 *   · Escape closes them all
 *
 * ⚠️ DELEGATED on document, never bound per card: collection cards are re-rendered by the
 * Meilisearch filter/sort JS, and listeners attached to the old nodes would silently stop working
 * after the first filter change. Capture phase so a card's own handlers cannot swallow the click.
 */
(function () {
  var SEL = 'details.llm-specs__more[open]';

  function closeAll(except) {
    document.querySelectorAll(SEL).forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var inside = t && t.closest ? t.closest('details.llm-specs__more') : null;
    // Clicking a summary toggles its own <details> natively; just close the others.
    closeAll(inside);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  /* ── TRUNCATED PLAIN VALUES BECOME A PREVIEW DROPDOWN (owner 2026-10-23) ─────────────────────
   * "I'm not seeing a dropdown for Absorbency: Max/Overnig..." — llm-spec-columns.liquid decides
   * the dropdown by CHARACTER COUNT (> 22), and "Max/Overnight" is 13, so it rendered plain and the
   * CSS ellipsised it once the list-view gutter narrowed the cell. Characters are a proxy for width;
   * the browser knows the real answer. Any plain value that is actually clipped
   * (scrollWidth > clientWidth) is rebuilt as the same <details> markup llm-spec-cell.liquid emits
   * for its preview variant, so it looks and behaves identically.
   * Upgrade only, never back: a cell that fits again after a resize keeps a harmless dropdown.
   * On phones values wrap instead of clipping, so nothing there is clipped and nothing changes.
   * Re-run on DOM changes because the Meilisearch filter/sort JS re-renders the cards.
   * ⚠️ SPEED (2026-10-28): measure EVERY cell first, then rebuild. Reading scrollWidth right after
   * rebuilding the previous cell forced a full-page layout per cell — about 3 s of main-thread time
   * on a phone (Lighthouse, adult-diapers), the main cause of the slow tap response (INP). */
  function upgrade() {
    var clipped = [];
    document.querySelectorAll('.llm-specs__cell:not(.llm-specs__cell--empty) > .llm-specs__value').forEach(function (dd) {
      if (!dd.querySelector('details') && dd.scrollWidth > dd.clientWidth + 1) clipped.push(dd);
    });
    clipped.forEach(function (dd) {
      var text = dd.textContent.trim();
      var d = document.createElement('details');
      d.className = 'llm-specs__more llm-specs__more--preview';
      var s = document.createElement('summary');
      s.className = 'llm-specs__more-sum';
      s.title = text.replace(/​/g, '');
      var span = document.createElement('span');
      span.className = 'llm-specs__more-text';
      span.textContent = text;
      s.appendChild(span);
      var ul = document.createElement('ul');
      ul.className = 'llm-specs__more-list';
      // the ZWSP soft-breaks are display-only; the list shows the clean strings, as the Liquid one does
      text.replace(/​/g, '').split(', ').forEach(function (p) {
        var li = document.createElement('li');
        li.textContent = p;
        ul.appendChild(li);
      });
      d.appendChild(s);
      d.appendChild(ul);
      dd.textContent = '';
      dd.appendChild(d);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; upgrade(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('load', schedule); // webfont swap can widen text after DOMContentLoaded
  window.addEventListener('resize', schedule);

  // Only additions that bring spec cells matter. Apps (wishlist, reviews, chat) add nodes all the time,
  // and re-scanning every card for each of them was wasted layout work. One observer serves both passes.
  function addsSpecs(muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.classList.contains('llm-specs__cell') || n.querySelector('.llm-specs__cell'))) return true;
      }
    }
    return false;
  }

  /* ── CLICK A VALUE → "Filter on …" (owner 2026-10-23) ─────────────────────────────────────────
   * "Since most of these attributes:values are also facets, could they be clickable to then filter?
   * But somehow make it so they have to click it twice." First click opens a small popover; only its
   * button filters. Two clicks because a list-view row is where people read and compare — a stray
   * click there must never silently narrow the grid.
   * Offered only where it can work: llm-meilisearch-collection.js exposes window.llmMeiliSpecFilter,
   * which says whether a value is a live facet on this page (shown as a filter, present in the current
   * distribution). Anywhere else (search page, a value that is not a facet) nothing is clickable.
   * The cell carries the RAW stored value (data-fraw) — the display value is abbreviated ("XL", "Yes").
   * A multi-value cell offers one button per value. In a "View All" dropdown each listed value is the
   * first click on its own.
   * The popover is a body-level fixed element: list cards clip overflow on phones, and a panel inside
   * the card would be cut off. It closes on scroll instead of following the page. */
  var pop = null;

  function filterApi() { return window.llmMeiliSpecFilter; }

  function cellParts(cell) {
    var api = filterApi();
    var key = cell.getAttribute('data-fkey');
    if (!api || !key) return [];
    return (cell.getAttribute('data-fraw') || '').split(', ').filter(function (v) {
      return v && api.has(key, v);
    });
  }

  // Style (data-flinks): "Show all …" LINKS to the style's collection, since a tag has no facet. A link
  // to the page you are already on is dropped, so on /collections/pull-up-style a Pull-Up row is plain.
  function cellLinks(cell) {
    var here = location.pathname.replace(/\/+$/, '');
    return (cell.getAttribute('data-flinks') || '').split('¦').map(function (s) {
      var p = s.split('|');
      return p[1] ? { label: p[0], href: p[1] } : null;
    }).filter(function (l) { return l && l.href !== here; });
  }

  function markFilterable() {
    document.querySelectorAll('.llm-specs__cell[data-flinks]').forEach(function (cell) {
      setFilterable(cell, cellLinks(cell).length > 0);
    });
    var api = filterApi();
    if (!api || !api.ready()) return;
    document.querySelectorAll('.llm-specs__cell[data-fkey]').forEach(function (cell) {
      setFilterable(cell, cellParts(cell).length > 0);
    });
  }

  function setFilterable(cell, on) {
    cell.classList.toggle('llm-specs__cell--filterable', on);
    var dd = cell.querySelector('.llm-specs__value');
    if (on && dd && !dd.querySelector('details')) {
      dd.setAttribute('tabindex', '0');
      dd.setAttribute('role', 'button');
      dd.setAttribute('aria-haspopup', 'dialog');
    }
  }

  // The card lifts on :hover (llm-page-tint.css). The popover lives on <body>, outside the card, so
  // moving the pointer onto it ended the hover and the card dropped back under it (owner 2026-10-23).
  // .llm-card--held keeps the lifted look while the popover is open.
  var heldCard = null;

  function closePop() {
    if (pop) { pop.remove(); pop = null; }
    if (heldCard) { heldCard.classList.remove('llm-card--held'); heldCard = null; }
  }

  function openPop(anchor, cell, values) {
    closePop();
    var api = filterApi();
    var key = cell.getAttribute('data-fkey');
    var label = (cell.querySelector('.llm-specs__label') || {}).textContent || '';
    pop = document.createElement('div');
    pop.className = 'llm-spec-filter-pop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', 'Filter by ' + label);
    if (cell.hasAttribute('data-flinks')) {
      // link mode (Style): real <a>s, so the second click is ordinary navigation
      cellLinks(cell).forEach(function (l) {
        var a = document.createElement('a');
        a.className = 'llm-spec-filter-pop__btn';
        a.href = l.href;
        a.textContent = 'Show all ' + l.label;
        pop.appendChild(a);
      });
      values = [];
    }
    values.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'llm-spec-filter-pop__btn';
      var name = api.label(key, v);
      if (api.active(key, v)) {
        b.disabled = true;
        b.textContent = 'Filtering on ' + name;
      } else {
        b.textContent = 'Filter on ' + name;
        b.addEventListener('click', function () {
          closePop();
          api.apply(key, v);
        });
      }
      pop.appendChild(b);
    });
    document.body.appendChild(pop);
    heldCard = cell.closest('.card--product');
    if (heldCard) heldCard.classList.add('llm-card--held');
    var r = anchor.getBoundingClientRect();
    var w = pop.offsetWidth, h = pop.offsetHeight;
    var left = Math.max(8, Math.min(r.left, window.innerWidth - w - 8));
    var top = r.bottom + 6;
    if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 6);
    pop.style.left = left + 'px';
    pop.style.top = top + 'px';
    var first = pop.querySelector('a, button:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (pop && pop.contains(t)) return;
    var cell = t.closest('.llm-specs__cell--filterable');
    // the dropdown's own caret/summary still just opens the dropdown
    if (!cell || t.closest('summary')) { closePop(); return; }
    var li = t.closest('.llm-specs__more-list li');
    if (li) {
      // ⚠️ The list may show DISPLAY values ("M", "XL") while the facet stores "Medium" / "X-Large", so
      // matching on the li text found nothing and the click silently did nothing (owner 2026-10-23).
      // Take the raw value at the same position from data-fraw; both lists come from one value in order.
      var lis = Array.prototype.slice.call(li.parentNode.children);
      var raws = (cell.getAttribute('data-fraw') || '').split(', ');
      var raw = raws.length === lis.length ? raws[lis.indexOf(li)] : li.textContent.trim();
      var api = filterApi();
      if (api && api.has(cell.getAttribute('data-fkey'), raw)) openPop(li, cell, [raw]);
      else closePop();
      return;
    }
    var dd = t.closest('.llm-specs__value');
    if (!dd) { closePop(); return; }
    openPop(dd, cell, cellParts(cell));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePop(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.llm-specs__cell--filterable > .llm-specs__value[role="button"]')) {
      e.preventDefault();
      openPop(e.target, e.target.parentNode, cellParts(e.target.parentNode));
    }
  });
  window.addEventListener('scroll', closePop, { passive: true });
  window.addEventListener('resize', closePop);

  var markQueued = false;
  function scheduleMark() {
    if (markQueued) return;
    markQueued = true;
    requestAnimationFrame(function () { markQueued = false; markFilterable(); });
  }
  document.addEventListener('llm:facets-ready', function () { closePop(); scheduleMark(); });
  new MutationObserver(function (muts) {
    if (addsSpecs(muts)) { schedule(); scheduleMark(); }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
